module.exports = __webpack_public_path__ + "img/login-v2.99da7e4e.svg";